import jwtDecode from 'jwt-decode';
import { getTokenFromCookies } from '../../hooks/useCookie';
// import { getSubscriptionWithEligibilityAndContactDetails } from '../../integration/eligibility.api';
import { CHANNEL } from './Constants';
// onload checking cartType and then token validation

const { ESHOP } = CHANNEL;
const getCookie = (cookies, name) => {
  const retrievedCookie = Object.keys(cookies)?.find(ele =>
    ele.toLowerCase().endsWith(name.toLowerCase())
  );
  if (retrievedCookie) {
    return cookies[retrievedCookie];
  }
  return null;
};
const validateCart = async cookies => {
  // const { reference, cartType, emailAddress, refreshToken, subscriptionId, accountId } = cookies;
  const reference = getCookie(cookies, 'reference');
  const cartType = getCookie(cookies, 'cart_Type');
  const emailAddress = getCookie(cookies, 'email_Address');
  const refreshToken = getCookie(cookies, 'refresh_Token');
  const subscriptionId = getCookie(cookies, 'subscription_Id');
  const accountId = getCookie(cookies, 'account_Id');
  const channel = getCookie(cookies, 'channel');
  const token = getTokenFromCookies(cookies);
  const result = {
    token,
  };
  if (!reference || !cartType) {
    // 1. Fresh Journey | No cart found on cookies
    // 2. NEW_ACQUISITION Journey exists.
    result.cartType = 'NEW_ACQUISITION';
    try {
      // 3.1 Token not found
      // console.log('token', token.length);
      if (token.length < 1) {
        result.isToken = false;
      } else {
        // 3.2 Validate token
        result.isToken = true;
        const { exp } = jwtDecode(token);
        // console.log(token);
        if (exp) {
          const expTime = new Date(new Date(0).setUTCSeconds(exp));
          result.validToken = expTime > new Date();
        }
      }
    } catch (error) {
      result.validToken = false;
      result.tokenError = error.message;
    }
  } else if (reference) {
    // 3. CROSS_SELL / CHANGE_OFFER Journey exists.
    result.cartType = cartType;
    result.reference = reference;
    result.rtoken = refreshToken || '';
    result.emailAddress = emailAddress || '';
    result.subscriptionId = subscriptionId || '';
    result.accountId = accountId || '';
    result.channel = channel || ESHOP;
    try {
      // 3.1 Token not found
      if (token.length < 1) {
        result.isToken = false;
        // result.validToken = false;
      } else {
        // 3.2 Validate token
        result.isToken = true;
        const { exp } = jwtDecode(token);
        if (exp) {
          const expTime = new Date(new Date(0).setUTCSeconds(exp));
          result.validToken = expTime > new Date();
        }
      }
    } catch (error) {
      result.validToken = false;
      result.tokenError = error.message;
    }
  }
  return result;
};

export default validateCart;
